import httpClient from './httpClient'

class ReportApi {
  static async fetchIOList(advertiserId, ioIdsStr) {
    try {
      const res = await httpClient.get(
        `/ad_report/${advertiserId}/dashboard/insertion_order`,
        {
          params: {
            // optional
            insertion_order_ids: ioIdsStr,
          },
        },
      )
      return res.data
    } catch (e) {
      console.log(e)
    }
  }

  static async fetchIOReport({
    advertiserId,
    insertionOrderId,
    startTime,
    endTime,
  }) {
    try {
      const res = await httpClient.get(
        `/ad_report/${advertiserId}/insertion_order`,
        {
          params: {
            // insertion_order_ids: insertionOrderIds,
            insertion_order_ids: insertionOrderId,
            // time formatかけるか
            // start_time: format(params.startTime, 'YY-MM-DD HH:mm:ss'),
            start_time: startTime,
            // end_time: format(params.endTime, 'YY-MM-DD HH:mm:ss'),
            end_time: endTime,
            // page_no: params.pageNo,
            // page_size: params.pageSize,
            // time_dimension: params.timeDimension
          },
        },
      )
      return res.data
    } catch (e) {
      console.log(e)
      return e
    }
  }

  static async fetchCampaignList(id, params) {
    try {
      const res = await httpClient.get(`/ad_report/${id}/dashboard/campaign`, {
        params,
      })
      return res.data
    } catch (e) {
      console.log(e)
    }
  }

  static async fetchCampaignReport(id, params) {
    try {
      const res = await httpClient.get(`/ad_report/${id}/campaign`, {
        params,
      })
      return res.data
    } catch (e) {
      console.log(e)
    }
  }

  static async fetchIOSparkLine({
    advertiserId,
    insertionOrderIds,
    startTime,
    endTime,
  }) {
    console.log(insertionOrderIds, 'IOIDs')
    try {
      const res = await httpClient.get(
        `/ad_report/${advertiserId}/insertion_order`,
        {
          params: {
            // insertion_order_ids: insertionOrderIds,
            insertion_order_ids: insertionOrderIds,
            // time formatかけるか
            // start_time: format(params.startTime, 'YY-MM-DD HH:mm:ss'),
            start_time: startTime,
            // end_time: format(params.endTime, 'YY-MM-DD HH:mm:ss'),
            end_time: endTime,
            // page_no: params.pageNo,
            // page_size: params.pageSize,
            // time_dimension: params.timeDimension
          },
        },
      )
      return res.data
    } catch (e) {
      console.log(e)
      return e
    }
  }
}

export default ReportApi
